import ModifyModal from './ModifyModal';

export default ModifyModal;



// WEBPACK FOOTER //
// ./src/components/ModifyModal/index.js